/*
 *
 * File: index.js
 *
 * Purpose: Booking app redux actions.
 *
 * Author:   Thomas Burgard (Software development)
 * Created: 23.02.2022
 *
 * Copyright (c) DrivePartner GmbH 2022
 *
 */

import * as api from "../../api";
import {
  GET_USERDATA,
  GET_PASSENGERDATA,
  GET_PASSENGER_BOOKINGS,
  CHANGE_LANGUAGE,
  GET_BOOKINGDATA,
  CLEAR_USERDATA_IN_STATE,
} from "../types";

/**
 * Get user data from Server-API with given username.
 *
 * @param {*} username user name
 * @returns user data payload
 */
export const getUserData = (username) => ({
  type: GET_USERDATA,
  payload: api.getUserData(username),
});

/**
 * Get passenger data from Server-API with given username, password & driverID.
 *
 * @param {*} username user name
 * @param {*} password user password
 * @param {*} driverID ID of driver
 * @returns passenger data payload
 */
export const getPassengerData = (username, password, driverID) => ({
  type: GET_PASSENGERDATA,
  payload: api.getPassengerData(username, password, driverID),
});

/**
 * Get passenger bookings from Server-API with given passenger ID & search item input.
 *
 * @param {*} year Given year
 * @param {*} month Given month
 * @param {*} passengerID ID of passenger
 * @param {*} driverID ID of driver
 * @param {*} pageNo Number of pages to show on screen
 * @param {*} pageSize Page size (how many bookings to show on screen)
 * @returns passenger bookings
 */
export const getPassengerBookings = (
  year,
  month,
  passengerID,
  driverID,
  pageNo,
  pageSize
) => ({
  type: GET_PASSENGER_BOOKINGS,
  payload: api.getPassengerBookings(
    year,
    month,
    passengerID,
    driverID,
    pageNo,
    pageSize
  ),
});

/**
 * Clear user data (from local storage) in state.
 *
 * @returns success string
 */
export const clearUserDataInState = () => ({
  type: CLEAR_USERDATA_IN_STATE,
  payload: "success cleared",
});

/**
 * Get booking data from Server-API with given ticket number.
 *
 * @param {*} userID ID of user (driver)
 * @param {*} ticketNumber ticket number of booking to change
 * @returns booking data
 */
export const getBookingData = (userID, ticketNumber) => ({
  type: GET_BOOKINGDATA,
  payload: api.getBookingData(userID, ticketNumber),
});

/**
 * Change language in app.
 *
 * @param {*} language ("de" or "en")
 * @returns -
 */
export const changeLanguage = (language) => ({
  type: CHANGE_LANGUAGE,
  payload: language,
});
